import { AlertTriangle } from "lucide-react";
import { scrollToId } from "../lib/smoothScroll";
import { CONTACT, links } from "../lib/contact";
import { PinMark } from "./PinMark";

export const Footer = () => (
  <footer className="relative bg-[#161521] text-white pt-16 pb-28 md:pb-10">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
      <div className="grid gap-10 lg:grid-cols-[1.4fr_1fr_1fr]">
        <div>
          <div className="flex items-center gap-3">
            <PinMark id="footerPin" className="h-9 w-9" />
            <span className="font-heading text-xl font-bold">Recovery Rides LLC</span>
          </div>
          <p className="mt-4 font-heading text-base text-[#1AD1B9] italic">
            Get There With Someone Who's Been There.
          </p>
          <p className="mt-4 text-sm text-white/60 leading-relaxed max-w-sm">
            Service area: Western Pennsylvania, Northwestern West Virginia, and Morgantown.
          </p>
        </div>

        <div>
          <h3 className="text-sm font-semibold uppercase tracking-wider text-white/50 mb-4">Contact</h3>
          <ul className="space-y-2.5 text-sm">
            <li><a href={links.call} className="text-white/80 hover:text-[#1AD1B9] transition-colors" data-testid="footer-phone">Phone: {CONTACT.phone}</a></li>
            <li><a href={links.text} className="text-white/80 hover:text-[#1AD1B9] transition-colors" data-testid="footer-text">Text: {CONTACT.text}</a></li>
            <li><a href={links.whatsapp} className="text-white/80 hover:text-[#1AD1B9] transition-colors" data-testid="footer-whatsapp">WhatsApp: {CONTACT.whatsapp}</a></li>
            <li><a href={links.serviceMail} className="text-white/80 hover:text-[#1AD1B9] transition-colors" data-testid="footer-email">Email: {CONTACT.serviceEmail}</a></li>
          </ul>
        </div>

        <div>
          <h3 className="text-sm font-semibold uppercase tracking-wider text-white/50 mb-4">Explore</h3>
          <ul className="space-y-2.5 text-sm">
            <li><button onClick={() => scrollToId("services")} className="text-white/80 hover:text-[#1AD1B9] transition-colors">Our Services</button></li>
            <li><button onClick={() => scrollToId("area")} className="text-white/80 hover:text-[#1AD1B9] transition-colors">Service Area</button></li>
            <li><button onClick={() => scrollToId("drivers")} className="text-white/80 hover:text-[#1AD1B9] transition-colors" data-testid="footer-drivers">Driver Opportunities</button></li>
            <li><a href="#" className="text-white/80 hover:text-[#1AD1B9] transition-colors">Privacy Policy</a></li>
            <li><a href="#" className="text-white/80 hover:text-[#1AD1B9] transition-colors">Terms of Service</a></li>
          </ul>
        </div>
      </div>

      <div className="mt-12 flex items-start gap-3 rounded-2xl bg-white/5 border border-white/10 p-5" data-testid="safety-notice">
        <AlertTriangle size={20} className="text-[#F59E0B] shrink-0 mt-0.5" />
        <p className="text-sm text-white/70 leading-relaxed">
          Recovery Rides is a transportation and concierge service. We are not an ambulance service, emergency
          medical service, treatment provider, or substitute for emergency care. If someone is experiencing a
          medical emergency, call 911.
        </p>
      </div>

      <div className="mt-8 pt-6 border-t border-white/10 text-sm text-white/50">
        © {new Date().getFullYear()} Recovery Rides LLC. All rights reserved.
      </div>
    </div>
  </footer>
);
